import { SvgIcon, SvgIconProps } from '@mui/material';

export const OrderUnPaidIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24.4987 3H3.4987C2.85437 3 2.33203 3.52233 2.33203 4.16667V7.66667C2.33203 8.311 2.85437 8.83333 3.4987 8.83333H24.4987C25.143 8.83333 25.6654 8.311 25.6654 7.66667V4.16667C25.6654 3.52233 25.143 3 24.4987 3Z'
          stroke='white'
          strokeWidth={2.2}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.66797 8.83203V21.6654C4.66797 22.2842 4.9138 22.8777 5.35139 23.3153C5.78897 23.7529 6.38246 23.9987 7.0013 23.9987H21.0013C21.6201 23.9987 22.2136 23.7529 22.6512 23.3153C23.0888 22.8777 23.3346 22.2842 23.3346 21.6654V8.83203'
          stroke='white'
          strokeWidth={2.2}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.6055 13L11.0011 18.4397'
          stroke='white'
          strokeWidth={2.2}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.8281 18.4805L11.3054 12.9578'
          stroke='white'
          strokeWidth={2.2}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
